import React from 'react';
import styles from './Usage.module.scss';
import ProfileWrapper from '../profileWrapper/ProfileWrapper';
const Usage = ({ user }) => {
  const fields = [
    { label: 'Number of questions', value: user?.numberOfQuestions || '-' },
    { label: 'Session Duration', value: user?.sessionDuration || '-' },
    {
      label: 'Number of prompt per session',
      value: user?.numberOfPrompts || '-',
    },
  ];

  return (
    <ProfileWrapper title='Usage'>
      <div className={styles.usageCont}>
        <div className={styles.cont}>
          {fields.map((field, index) => (
            <div key={index} className={styles.details}>
              <h3>{field.label}</h3>
              <p>{field.value}</p>
            </div>
          ))}
        </div>
      </div>
    </ProfileWrapper>
  );
};

export default Usage;
